import { useMemo } from 'react';

import { EntitlementTypeWithDescription } from '@dreryk/drerykweb-medical-dictionaries-api';

import { createTranslatedText } from '@dreryk/react-common';
import {
   IconFillColor,
   IconSize,
   IconWrapper,
   QuestionmarkCircleIcon,
   Tooltip,
   TooltipPlacement,
} from '@dreryk/react-components';

type PatientEntitlementTypeTooltipProps = {
   readonly entitlementTypes: EntitlementTypeWithDescription[];
};

export const PatientEntitlementTypeTooltip = (props: PatientEntitlementTypeTooltipProps): JSX.Element => {
   const content = useMemo(() => {
      return createTranslatedText(
         props.entitlementTypes
            .map(({ entitlementType, description }) => `${entitlementType} - ${description}`)
            .join('/n')
      );
   }, [props.entitlementTypes]);

   return (
      <Tooltip testId={'entitlementType'} content={content} placement={TooltipPlacement.TOP}>
         <IconWrapper testId={'entitlementType'} fillColor={IconFillColor.PRIMARY} size={IconSize.SMALL}>
            <QuestionmarkCircleIcon />
         </IconWrapper>
      </Tooltip>
   );
};
